// tyrant-throne.midokuni.com
import { useStorageState } from "Hooks/useStorageState";
import IStyle from "Interfaces/IStyle";
import React, { useEffect, useState } from "react";
import { Button, Card, Row } from "react-bootstrap";
import { getJson } from "Utils/Common";
import { IStellaSoraCharacter, StellaSoraCharacter } from "Views/StellaSora/Models";

const styles:IStyle = {
	cardContainer: {
		display: "flex", 
		flexDirection: "row", 
		flexWrap: "wrap"
	},
	cardGroup: {
		margin: "1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
		border: "1px solid",
		borderColor: "pink",
	},
	compactCardGroup: {
		margin: "0.1em 1em 0.1em 1em",
		zIndex: 1,
		padding: "0 0.3em 0 0.3em",
		display: "block",
		marginBottom: "auto",
		marginTop: "5px",
		border: "1px dotted"
	},
	card: {
		textAlign: "center",
		display: "block",
		marginBottom: "auto",
		marginLeft: "auto",
		marginRight: "auto",
	},
	spinnerRow: {
		// alignContent: "center",
		// alignItems: "center",
		// alignSelf: "center",
		// textAlign: "center"
		zIndex: 10
	},
	button: {
		marginRight: 5
	},
	buttonLink: {
		margin: 5,
	},
}

export default function HeartLink() {
	const DATA_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/character.json';
	// const ITEM_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/item.json';
	// const WORD_URL = 'https://raw.githubusercontent.com/AutumnVN/StellaSoraData/refs/heads/main/word.json';
	const [characters, setCharacters] = useState<StellaSoraCharacter[]>([]);
	const [hiddenDates, setHiddenDates] = useStorageState<{
		[id:number]: string[]
	}>({}, "midokuni.stella-sora.dates.hide", (str) => JSON.parse(str));
	const [showHidden, setShowHidden] = useState(false);
	useEffect(() => {
		async function fetchData() {
			const charaTask = getJson(DATA_URL);
			setCharacters(Object.values(await charaTask).map(chara=>new StellaSoraCharacter(chara as IStellaSoraCharacter)));
		}
		fetchData();
	},[]);
	characters.sort((a,b)=>a.name.localeCompare(b.name));
	return (<>
	<h3 className="text-pink">Tyrant Throne - Heartlink Invitations</h3>
	<Button variant="violet" onClick={(e)=>{setShowHidden(!showHidden)}}>{showHidden ? "Hide" : "Show" } Hidden</Button><Button variant="violet" onClick={(e)=>{setHiddenDates({})}}>Reset Hidden</Button>
	<div style={styles.cardContainer}>
		{characters.map(char=>(<>{
			char.date.filter(dateEntry=>showHidden || !hiddenDates[char.id]?.includes(dateEntry.clue)).map((dateEntry:any)=>{
				const isHidden = hiddenDates[char.id]?.includes(dateEntry['clue']);
				return (<div style={{margin:3}}>
				<Card style={{width: "12vw", minWidth:"220px", height: "100%", objectFit: "cover"}}>
					<Card.Body>
						<Card.Img variant="left" src={char.getIcon()} style={{width: 70, height: 70, marginLeft: 0, objectFit: "cover", float:"right", opacity: isHidden ? 0.4 : 1}}/>
						<Card.Title className="text-pink">
						<span className="btn-close" style={{marginRight: "0.3em"}} onClick={()=>{
							const temp = hiddenDates;
							if (!!!temp[char.id]) temp[char.id] = [dateEntry['clue']];
							else if (!isHidden) temp[char.id].push(dateEntry['clue']);
							else delete temp[char.id][temp[char.id].indexOf(dateEntry['clue'])];
							setHiddenDates({...temp});
						}}/>{char.name}</Card.Title>
						<Card.Subtitle className="text-pink">{dateEntry['clue'].replaceAll(/Visit the | to unlock/gi,"")}</Card.Subtitle>
						<Card.Text>{dateEntry['secondChoice']}</Card.Text>
					</Card.Body>
				</Card>
			</div>)})
		}
		</>))}
	</div>
	<Row className="responsive-font"><p>The data used here is processed from <a href="https://stelladb.pages.dev">StellaDB</a></p></Row>
	<Row className="responsive-font"><p>I'm lazy to set up another webpage for SS. For now I'm putting it here.</p></Row>
	</>);
}